// Back to top button
$('.back-to-top-link').on('click', function(e) {
 e.preventDefault();
 $('html, body').animate({ scrollTop: 0 }, '800', function() {
   $('body').trigger('click');
 });
});

// Fade in/out .back-to-top
$(window).scroll(function(){
 if ($(this).scrollTop() > 300) {
   $('.back-to-top').fadeIn();
 } else {
   $('.back-to-top').fadeOut();
 }
});
